import {
  setAlertWithTitle,
  setItemVarientsList,
  setItemVarientsStatus,
  setSessionExpired,
  setSpinnerLoading,
} from "../utility/Redux/modal";
import moment from "moment";
import { setItemList, setSectionList } from "../utility/Redux/list";
import qz from "qz-tray";
import CategoryIcon from "@mui/icons-material/Category";
import StarsIcon from "@mui/icons-material/Stars";
import {
  FontSizeWidth,
  getItemByCodeFromPurchase,
  getMessageWallet,
  isPosMod,
} from "../utility/constant";
import HandleIndexedDB from "../Test/handleIndexDb";
import uniqueId from "uniqid";
import { Box, ButtonBase, Fade, Tab, Tabs, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { toProperCase } from "../utility/component/format";
import {
  SaveCustomerMasterAPI,
  UpdateOrderAccepted,
} from "../utility/functions/common";
import { FormatNumber2 } from "../utility/functions/formatNumber";
import dataToLocal from "../utility/component/dataToLocal";
import deleteWholeDatabase from "../utility/functions/deleteWholeDatabase";
import PlaceHolderTextInput from "../utility/component/geniusComponents/placeTextInput";
import { useEffect, useState } from "react";
import CallAPI from "../utility/functions/getData";
import Store from "../utility/Redux/store";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import NumberToWords3 from "../utility/component/numberToFormat";
import { CallAPIPromise } from "../billing/common";
import { orderTypeList } from "./common";
export const loadImageAsBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Important if loading from an external URL
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png")); // Convert to Base64
    };
    img.onerror = (error) => reject(error);
  });
};
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (
      document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      )
    ) {
      resolve(true); // Already loaded
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const generateThermalPDF = async (isOriginalBill, printData) => {
  const dispatch = Store.dispatch;
  dispatch(setSpinnerLoading("Printing"));
  const pdf = new jsPDF("p", "mm", [58, 297]); // Thermal paper size
  const pageWidth = pdf.internal.pageSize.getWidth();
  const comapnyAddress = Store.getState().profile.companyAddress;
  try {
    const logoBase64 = await loadImageAsBase64(
      require("../utility/Logo/icons/orangeIcon.png")
    );
    pdf.addImage(logoBase64, "PNG", (pageWidth - 20) / 2, 5, 20, 20);
  } catch (error) {
    console.error("Failed to load logo:", error);
  }

  let yPosition = 30;
  pdf.setFontSize(8);
  pdf.text(comapnyAddress.companyName, pageWidth / 2, yPosition, {
    align: "center",
  });

  yPosition += 5;
  pdf.setFontSize(6);
  pdf.text(
    `${comapnyAddress.address}, ${comapnyAddress.city}`,
    pageWidth / 2,
    yPosition,
    { align: "center" }
  );
  yPosition += 4;
  pdf.text(comapnyAddress.email, pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += 4;
  pdf.text(comapnyAddress.companyWebsite, pageWidth / 2, yPosition, {
    align: "center",
  });

  yPosition += 6;
  pdf.setLineDash([1, 1], 0);
  pdf.line(5, yPosition, 75, yPosition);
  yPosition += 6;

  pdf.setFontSize(7);
  pdf.text("RETAIL INVOICE", pageWidth / 2, yPosition, { align: "center" });

  yPosition += 6;
  if (!isOriginalBill) {
    pdf.text("Duplicate Bill", pageWidth / 2, yPosition, { align: "center" });
    yPosition += 6;
  }

  const billNo = `Bill No.: ${printData[0]?.INVNO}`;
  const billDate = printData[0]?.DATE
    ? `${moment.utc(printData[0]?.DATE).format("DD/MM/yyyy")}`
    : "";
  pdf.text(billNo, 5, yPosition);
  pdf.text(billDate, 40, yPosition); // Right side

  yPosition += 5;

  pdf.setLineDash([1, 1], 0);
  pdf.line(5, yPosition, 75, yPosition);
  yPosition += 6;

  const data = printData.map((p) => [
    p.ITEMNAME,
    p.QNTY,
    FormatNumber2(p.AMOUNT),
  ]);
  autoTable(pdf, {
    startY: yPosition,
    margin: { left: 5, right: 5 },
    head: [["Item", "Qty", "Amount"]],
    body: data,
    theme: "plain",
    headStyles: { fontSize: 6, textColor: [0, 0, 0] },
    styles: { fontSize: 6 },
    columnStyles: { 1: { halign: "center" }, 2: { halign: "right" } },
  });

  let finalY = pdf.lastAutoTable.finalY;
  pdf.setLineDash([]);
  pdf.line(5, finalY, 75, finalY);
  finalY += 4;

  pdf.setFontSize(7);
  pdf.text("Total:", 40, finalY, { align: "right" });
  pdf.text(
    FormatNumber2(
      printData.reduce((total, row) => total + Number(row.AMOUNT), 0)
    ),
    55,
    finalY,
    { align: "right" }
  );
  finalY += 4;

  pdf.text("Tax:", 40, finalY, { align: "right" });
  pdf.text(
    FormatNumber2(
      printData.reduce(
        (acc, row) => acc + Number(row.TAX1_AMT) + Number(row.TAX2_AMT),
        0
      )
    ),
    55,
    finalY,
    { align: "right" }
  );
  finalY += 4;

  pdf.text("Round Off:", 40, finalY, { align: "right" });
  pdf.text(FormatNumber2(printData[0]?.ROUND_OFF), 55, finalY, {
    align: "right",
  });
  finalY += 4;
  pdf.setFont("helvetica", "bold");

  pdf.text("Grand Total:", 40, finalY, { align: "right" });
  pdf.text(FormatNumber2(printData[0]?.GTOTAL), 55, finalY, {
    align: "right",
  });
  finalY += 4;
  pdf.setFont("helvetica", "normal");

  pdf.setLineDash([]);
  pdf.line(5, finalY, 75, finalY);
  finalY += 5;

  pdf.setFontSize(7);
  pdf.text(
    toProperCase(NumberToWords3(printData[0]?.GTOTAL)),
    pageWidth / 2,
    finalY,
    { align: "center" }
  );
  finalY += 4;

  pdf.setLineDash([1, 1, 0]);
  pdf.setLineWidth(0.5);

  pdf.line(5, finalY, 75, finalY);
  finalY += 7;
  pdf.setFont("helvetica", "bold");
  pdf.text("Amount Received", pageWidth / 2, finalY, {
    align: "center",
  });
  finalY += 7;

  pdf.setFont("helvetica", "normal");
  if (printData[0]?.CASH_AMOUNT) {
    pdf.text(
      `Cash Amount: ${FormatNumber2(printData[0]?.CASH_AMOUNT)}`,
      pageWidth / 2,
      finalY,
      { align: "center" }
    );
    finalY += 6;
  }
  if (printData[0]?.CARD_AMOUNT) {
    const cardText = `Card Amount: ${FormatNumber2(
      printData[0]?.CARD_AMOUNT
    )} [${printData[0]?.CARD_NO}]`;
    pdf.text(cardText, pageWidth / 2, finalY, { align: "center" });
    finalY += 6;
  }
  pdf.setLineWidth(0.01);
  pdf.setLineDash([1, 1]); // Dotted pattern
  pdf.line(5, finalY, 75, finalY);
  finalY += 10;

  pdf.text(
    "All Disputes Subjected to Jalandhar Jurisdiction.",
    pageWidth / 2,
    finalY,
    {
      align: "center",
    }
  );
  finalY += 6;
  pdf.text("Powered by geniusoffice .", pageWidth / 2, finalY, {
    align: "center",
  });
  connectPrinterAndList(pdf).finally(() => {
    dispatch(setSpinnerLoading(false));
  });
  return pdf.output("datauristring");
};
export const GetOrderSummary = (data, token, dispatch, setSummaryList) => {
  dispatch(setSpinnerLoading("Loading"));
  CallAPI(
    "/api/dispatch/orderSummary",
    {
      ...data,
    },
    token,
    (e) => {
      if (!e.data.error) {
        if (e.data.response[0]) {
          setSummaryList(e.data.response);
        } else {
          setSummaryList([]);
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
export const generatePDF = async (isOriginalBill, printData) => {
  const dispatch = Store.dispatch;

  dispatch(setSpinnerLoading("Printing"));
  const comapnyAddress = Store.getState().profile.companyAddress;

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();

  try {
    // Load and add logo
    const logoBase64 = await loadImageAsBase64(
      require("../utility/Logo/icons/orangeIcon.png")
    );
    const logoWidth = 20;
    const logoHeight = 20;
    const centerX = (pageWidth - logoWidth) / 2;

    pdf.addImage(logoBase64, "PNG", centerX, 5, logoWidth, logoHeight);
  } catch (error) {
    console.error("Failed to load logo:", error);
  }

  let yPosition = 30; // Adjust based on logo height

  // Company Information (Centered)
  pdf.setFontSize(18);
  pdf.text(comapnyAddress.companyName, pageWidth / 2, yPosition, {
    align: "center",
  });

  yPosition += 6;
  pdf.setFontSize(12);
  pdf.text(
    `${comapnyAddress.address}, ${comapnyAddress.state}, ${comapnyAddress.city}, ${comapnyAddress.mobile}`,
    pageWidth / 2,
    yPosition,
    { align: "center" }
  );

  yPosition += 6;
  pdf.text(comapnyAddress.email, pageWidth / 2, yPosition, {
    align: "center",
  });

  yPosition += 6;
  pdf.text(comapnyAddress.companyWebsite, pageWidth / 2, yPosition, {
    align: "center",
  });

  yPosition += 10;
  pdf.setLineWidth(0.01);
  pdf.setLineDash([1, 1], 0); // Dotted pattern
  pdf.line(10, yPosition, 200, yPosition);

  yPosition += 10;

  pdf.setFontSize(13);
  pdf.text("RETAIL INVOICE", pageWidth / 2, yPosition, { align: "center" });

  yPosition += 7;
  pdf.setFontSize(12);
  if (!isOriginalBill) {
    pdf.text("Duplicate Bill", pageWidth / 2, yPosition, { align: "center" });

    yPosition += 7;
  }

  // Bill No. on the left and Date on the right
  const billNo = `Bill No.: ${printData[0]?.INVNO}`;
  const billDate = printData[0]?.DATE
    ? `Date: ${moment.utc(printData[0]?.DATE).format("DD/MM/yyyy")}`
    : "";

  pdf.setFontSize(12);
  pdf.text(billNo, 10, yPosition); // Left side
  pdf.text(billDate, pdf.internal.pageSize.getWidth() - 50, yPosition); // Right side

  yPosition += 5; // Move down slightly

  // Add an underline (solid line below)

  pdf.setLineDash([1, 1], 0);
  pdf.line(10, yPosition, 200, yPosition);
  pdf.setLineDash([]); // Solid line
  yPosition += 8;
  const totalQnty = printData.reduce(
    (total, row) => Number(total) + Number(row.QNTY),
    0
  );

  pdf.setFontSize(12);
  pdf.text(`Bill Status : ${printData[0]?.BILL_STATUS}`, 10, yPosition); // Left side
  const data = printData.map((p) => [
    p.ITEMNAME,
    FormatNumber2(p.SALE_PRICE),
    p.QNTY,
    p.RQNTY,
    FormatNumber2(p.SALE_PRICE),
  ]);
  autoTable(pdf, {
    startY: yPosition + 5,
    margin: { left: 10, right: 10 }, // Set left margin to 10 (Aligns table from x = 10
    head: [["Item Name", "Rate", "Qnty", "Return", "Amount"]],
    body: data,
    theme: "plain", // No background color
    headStyles: {
      halign: "center", // Center header text
      fontStyle: "bold",
      fillColor: [255, 255, 255], // No background color
      textColor: [0, 0, 0], // Black text
      lineWidth: 0.1, // Border thickness
      lineColor: [0, 0, 0], // Black border color
    },
    styles: { fontSize: 10 }, // Optional: Adjust font size
    columnStyles: {
      1: { halign: "right" }, // Align "Rate" column to the right (index 1)
      4: { halign: "right" }, // Align "Amount" column to the right (index 4)
      2: { halign: "center" }, // Align "Amount" column to the center (index 4)
      3: { halign: "center" }, // Align "Amount" column to the right (index 4)
    },
    // didDrawCell: function (data) {
    //   // Draw right border for the last column
    //   pdf.setDrawColor(0); // Black color
    //   pdf.setLineWidth(0.1); // Border thickness
    //   pdf.line(
    //     data.cell.x + data.cell.width, // X start (end of cell)
    //     data.cell.y, // Y start
    //     data.cell.x + data.cell.width, // X end (same as start)
    //     data.cell.y + data.cell.height // Y end (bottom of cell)
    //   );
    // },
  });

  let finalY = pdf.lastAutoTable.finalY; // Adjust spacing

  // Solid Line Below Table
  pdf.setLineDash([]); // Solid line
  pdf.setLineWidth(0.5);
  pdf.line(10, finalY, 200, finalY);
  finalY += 7;
  pdf.text(
    "Total :",
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );
  pdf.text(
    FormatNumber2(
      printData.reduce((total, row) => Number(total) + Number(row.AMOUNT), 0)
    ),
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      10 +
      pdf.lastAutoTable.columns[4].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );
  // Tax, Round Off & Grand Total
  finalY += 8;
  pdf.setFontSize(12);
  pdf.text(
    "Tax Amount :",
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );
  pdf.text(
    FormatNumber2(
      printData.reduce(
        (acc, row) =>
          acc +
          Number(
            Number(row.TAX1_AMT) + Number(row.TAX2_AMT) + Number(row.TAX3_AMT)
          ),
        0
      )
    ),
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      10 +
      pdf.lastAutoTable.columns[4].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );

  finalY += 8;
  pdf.text(
    "Round Off :",
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );
  pdf.text(
    FormatNumber2(printData[0]?.ROUND_OFF),
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      10 +
      pdf.lastAutoTable.columns[4].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );

  finalY += 4;
  pdf.setLineDash([]); // Solid line
  pdf.setLineWidth(0.5);
  pdf.line(10, finalY, 200, finalY);
  finalY += 7;
  pdf.setFont("helvetica", "bold");

  pdf.text(
    "Grand Total :",
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );

  pdf.text(
    FormatNumber2(printData[0].GTOTAL),
    pdf.lastAutoTable.columns[0].width +
      pdf.lastAutoTable.columns[1].width +
      pdf.lastAutoTable.columns[3].width +
      10 +
      pdf.lastAutoTable.columns[4].width +
      pdf.lastAutoTable.columns[2].width,
    finalY,
    {
      align: "right",
    }
  );
  pdf.setFont("helvetica", "normal");

  // Another Solid Line
  finalY += 5;
  pdf.setLineDash([]); // Solid line
  pdf.setLineWidth(0.5);
  pdf.line(10, finalY, 200, finalY);

  // Amount Received
  finalY += 8;
  pdf.setFontSize(12);
  pdf.text(
    toProperCase(NumberToWords3(printData[0]?.GTOTAL)),
    pageWidth / 2,
    finalY,
    {
      align: "center",
    }
  );
  finalY += 5;

  pdf.setLineDash([1, 1], 0);
  pdf.setLineWidth(0.5);

  pdf.line(10, finalY, 200, finalY);
  // "All disputes subject to Jalandhar"
  finalY += 7;
  pdf.setFont("helvetica", "bold");
  pdf.text("Amount Received", pageWidth / 2, finalY, {
    align: "center",
  });
  finalY += 7;
  pdf.setFontSize(12);

  pdf.setFont("helvetica", "normal");

  if (printData[0]?.CASH_AMOUNT) {
    pdf.text(
      `Cash Amount: ${FormatNumber2(printData[0]?.CASH_AMOUNT)}`,
      pageWidth / 2,
      finalY,
      { align: "center" }
    );
    finalY += 6;
  }

  if (printData[0]?.CARD_AMOUNT) {
    const cardText = `Card Amount: ${FormatNumber2(
      printData[0]?.CARD_AMOUNT
    )} [${printData[0]?.CARD_NO}]`;
    pdf.text(cardText, pageWidth / 2, finalY, { align: "center" });
    finalY += 6;
  }
  pdf.setLineWidth(0.01);
  pdf.setLineDash([1, 1], 0); // Dotted pattern
  pdf.line(10, finalY, 200, finalY);
  pdf.setFontSize(10);
  finalY += 10;

  pdf.text(
    "All Disputes Subjected to Jalandhar Jurisdiction.",
    pageWidth / 2,
    finalY,
    {
      align: "center",
    }
  );
  finalY += 6;
  pdf.text("Powered by geniusoffice .", pageWidth / 2, finalY, {
    align: "center",
  });
  // setPdfPreview(pdf.output("bloburl"));
  connectPrinterAndList(pdf).finally(() => {
    dispatch(setSpinnerLoading(false));
  });
  return pdf.output("datauristring");
};
export const connectPrinterAndList = () => {
  const dispatch = Store.dispatch;
  const state = Store.getState();
  const token = state.security.token;
  return new Promise((resolve, reject) => {
    // Check if QZ Tray WebSocket is already active
    if (qz.websocket.isActive()) {
      // If connected, directly find printers
      qz.printers
        .find()
        .then((printers) => {
          resolve(printers);
        })
        .catch((err) => {
          dispatch(
            setAlertWithTitle({
              title: "QZ Tray Application",
              msg: "Run Qz Tray Application to connect printer",
            })
          );
          console.error("Error finding printers:", err);
          reject(err); // Reject the promise if there's an error
        });
    } else {
      qz.security.setCertificatePromise(function (resolve, reject) {
        // Preferred method - from server
        fetch("../../digital-certificate.txt", {
          cache: "no-store",
          headers: { "Content-Type": "text/plain" },
        }).then(function (data) {
          data.ok ? resolve(data.text()) : reject(data.text());
        });
      });

      qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
      qz.security.setSignaturePromise(function (toSign) {
        return function (resolve, reject) {
          CallAPIPromise(
            `/api/barCodeSignIn/barCodePrivateKey`,
            {
              toSign: toSign,
            },
            token
          )
            .then((res) => {
              if (res.data.signature) {
                resolve(res.data.signature);
              }
            })
            .catch((e) => console.error(e));
        };
      });

      qz.websocket
        .connect()
        .then(() => {
          qz.printers
            .find()
            .then((printers) => {
              resolve(printers);
            })
            .catch((err) => {
              console.error("Error finding printers:", err);
              reject(err); // Reject the promise if there's an error
            });
        })
        .catch((err) => {
          console.error("Connection Error:", err);
          reject(err); // Reject the promise if connection fails
        });
    }
  });
};

export const GetSuspendedOrderSummary = (
  data,
  token,
  dispatch,
  setSummaryList
) => {
  dispatch(setSpinnerLoading("Loading"));
  CallAPI(
    "/api/crossCustomerOrder/suspendedOrderSummary",
    {
      ...data,
      ITEMNAME: "",
    },
    token,
    (e) => {
      if (!e.data.error) {
        if (e.data.response[0]) {
          setSummaryList(e.data.response);
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
export const GetListItemMaster = (
  prefix,
  sectionName,
  token,
  dispatch,
  dd,
  setFullItemList,
  setList,
  pageNumber,
  setTotalPagelist,
  accountdetails,
  orderType,
  itemName,
  brand,
  ICODE,
  ALIOS
) => {
  return new Promise((resolve, reject) => {
    const data = {
      table_prefix: prefix,
      SECTION_NAME: sectionName ? sectionName : "",
      ICODE: ICODE ? ICODE : "",
      ITEMNAME: itemName ? itemName : "",
      ALIAS_CODE: ALIOS ? ALIOS : "",
      page: pageNumber ? pageNumber : 1,
      limit: 100,
      ACCOUNT_NO: accountdetails ? accountdetails.ACCOUNT_NO : "",
      BRAND_NAME: brand ? brand : "",
      PAGE:pageNumber?pageNumber:1,

    };

    dispatch(setSpinnerLoading("Loading Items"));
    CallAPIPromise("/api/stockorders/loadOrderItems", data, token)
      .then((e) => {
        if (!e.data.error) {
          resolve(e.data.response);
          setList(e.data.response);
          setTotalPagelist(1);
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  });
};
export function SectionlistUI({
  sectionList,
  sectionName,
  setSectionName,
  prefix,
  token,
  dispatch,
  setItemList,
  currentItemsPage,
  setTotalItemsPage,
  setCurrentItemPage,
  setBillCartList,
  billingDetails,
  customerDetails,
  setAlertTwoButtonModal,
  profileSetting,
  billCartList,
  accountdetails,
  orderType,
}) {
  const [searchText, setSearchText] = useState("");
  const [tab, setTab] = useState(0);
  const [list, setList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  useEffect(() => {
    if (searchText) {
      setList(
        list.filter((o) => o.SECTION_NAME.toLowerCase().includes(searchText))
      );
    } else {
      setList(sectionList);
    }
  }, [searchText, sectionList]);

  useEffect(() => {
    CallAPIPromise("/api/subMasterUtils/brandNamerHelp", {
      table_prefix: prefix,
    }).then((res) => {
      if (!res.data.error) {
        setBrandList(res.data.response.filter((b) => b.BRAND_NAME));
      }
    });
  }, []);

  return (
    <div className="h-full   flex flex-col grow  ml-2">
      <PlaceHolderTextInput
        icon={
          <i className="bi mx-2 bi-search text-[#b5b3b3]  flex  items-center"></i>
        }
        autoFocus={window.innerWidth > 1280}
        id={"search"}
        autoFill={"off"}
        type={"text"}
        placeholder={"Search Section"}
        value={searchText}
        onchange={(e) => {
          setSearchText(e.target.value);
        }}
      />

      <div className="border-[#A09E9E] bg-[#f8f8fd] mt-2 shadow-sm p-2 border rounded-sm flex flex-col h-full overflow-y-auto">
        <CustomTabs tab={tab} setTab={setTab} />

        <div className="grid grid-cols-1  ll:grid-cols-2 w-full bg-white rounded-b-sm gap-2  ">
          {tab === 0 &&
            list.map((item, key) => {
              const isinBillCart = billCartList.find(
                (b) => b.SECTION_NAME === item.SECTION_NAME
              );
              return (
                <div
                  key={key}
                  className="flex overflow-hidden"
                  style={{
                    border:
                      item.SECTION_NAME === sectionName
                        ? "2px solid #A8CF45"
                        : "0px solid #A8CF45",
                    height: "45px",
                    boxShadow: "1px 1px 1px 0px #e6e6e3",
                    borderRadius: "7px",
                    textTransform: "none",
                    backgroundColor: isinBillCart ? "#f5874f" : "#f5eb82",
                    fontSize: FontSizeWidth(window.innerWidth),
                    color: isinBillCart ? "white" : "#4a4a4a",
                  }}
                >
                  <button
                    onClick={(e) => {
                      setCurrentItemPage(1);
                      setSectionName(item.SECTION_NAME);

                      if (
                        (orderType === orderTypeList[1].value &&
                          accountdetails?.ACCOUNT_NO) ||
                        orderType === orderTypeList[0].value ||
                        (orderType === orderTypeList[2].value &&
                          accountdetails?.ACCOUNT_NO)
                      ) {
                        GetListItemMaster(
                          prefix,
                          item.SECTION_NAME,
                          token,
                          dispatch,
                          "",
                          "",
                          setItemList,
                          currentItemsPage,
                          setTotalItemsPage,
                          accountdetails,
                          orderType
                        ).then((res) => {
                          res.map((o) => {
                            itemClick(
                              o,
                              o,
                              setBillCartList,
                              billingDetails,
                              customerDetails,
                              o.ORDER_QNTY === 0 ? "ZERO" : o.ORDER_QNTY,
                              dispatch,
                              setAlertTwoButtonModal,
                              true,
                              "",
                              "",
                              "",
                              false,
                              profileSetting,
                              billCartList,
                              orderType
                            );
                          });
                        });
                      } else {
                        if (
                          orderType === orderTypeList[1].value ||
                          orderType === orderTypeList[2].value
                        ) {
                          dispatch(
                            setAlertWithTitle({
                              title: "Account No.",
                              msg: "Please select any account number",
                            })
                          );
                        }
                      }
                    }}
                    style={{
                      width: `calc(100% - 20px)`,
                    }}
                    className=" px-2 text-start  font-semibold whitespace-nowrap "
                  >
                    {toProperCase(item.SECTION_NAME)}
                  </button>
                  <Fade
                    orientation="horizontal"
                    in={item.SECTION_NAME === sectionName}
                  >
                    <button
                      style={{
                        paddingRight: "5px",
                        paddingLeft: "5px",
                      }}
                      className="bg-green h-full"
                      onClick={() => {
                        setSectionName("");
                        setItemList([]);
                      }}
                    >
                      <Close
                        color="white"
                        fontSize={"small"}
                        sx={{
                          fontSize: "15px",
                          color: "white",
                        }}
                      />
                    </button>
                  </Fade>
                </div>
              );
            })}
          {tab === 1 &&
            brandList.map((item, key) => {
              const isinBillCart = billCartList.find(
                (b) => b.BRAND_NAME === item.BRAND_NAME
              );
              return (
                <div
                  key={key}
                  className="flex overflow-hidden"
                  style={{
                    border:
                      item.SECTION_NAME === sectionName
                        ? "2px solid #A8CF45"
                        : "0px solid #A8CF45",
                    height: "45px",
                    boxShadow: "1px 1px 1px 0px #e6e6e3",
                    borderRadius: "7px",
                    textTransform: "none",
                    backgroundColor: isinBillCart ? "#a8cf45" : "#f5eb82",
                    fontSize: FontSizeWidth(window.innerWidth),
                    color: isinBillCart ? "white" : "#4a4a4a",
                  }}
                >
                  <button
                    onClick={(e) => {
                      setCurrentItemPage(1);
                      setSelectedBrand(item.BRAND_NAME);

                      if (
                        (orderType === orderTypeList[1].value &&
                          accountdetails?.ACCOUNT_NO) ||
                        orderType === orderTypeList[0].value ||
                        (orderType === orderTypeList[2].value &&
                          accountdetails?.ACCOUNT_NO)
                      ) {
                        GetListItemMaster(
                          prefix,
                          "",
                          token,
                          dispatch,
                          "",
                          "",
                          setItemList,
                          currentItemsPage,
                          setTotalItemsPage,
                          accountdetails,
                          orderType,
                          "",
                          item.BRAND_NAME
                        ).then((res) => {
                          res.map((o) => {
                            itemClick(
                              o,
                              o,
                              setBillCartList,
                              billingDetails,
                              customerDetails,
                              o.ORDER_QNTY === 0 ? "ZERO" : o.ORDER_QNTY,
                              dispatch,
                              setAlertTwoButtonModal,
                              true,
                              "",
                              "",
                              "",
                              false,
                              profileSetting,
                              billCartList,
                              orderType
                            );
                          });
                        });
                      } else {
                        if (
                          orderType === orderTypeList[1].value ||
                          orderType === orderTypeList[2].value
                        ) {
                          dispatch(
                            setAlertWithTitle({
                              title: "Account No.",
                              msg: "Please select any account number",
                            })
                          );
                        }
                      }
                    }}
                    style={{
                      width: `calc(100% - 20px)`,
                    }}
                    className=" px-2 text-start  font-semibold whitespace-nowrap "
                  >
                    {toProperCase(item.BRAND_NAME)}
                  </button>
                  <Fade
                    orientation="horizontal"
                    in={item.BRAND_NAME === selectedBrand}
                  >
                    <button
                      style={{
                        paddingRight: "5px",
                        paddingLeft: "5px",
                      }}
                      className="bg-green h-full"
                      onClick={() => {
                        setSelectedBrand("");
                      }}
                    >
                      <Close
                        color="white"
                        fontSize={"small"}
                        sx={{
                          fontSize: "15px",
                          color: "white",
                        }}
                      />
                    </button>
                  </Fade>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
export const GetPurchaseBill = (prefix, token, dispatch, setBillCartList) => {
  const data = { table_prefix: prefix, CUSTOMER_NAME: "", CUSTOMER_MOBILE: "" };
  CallAPIPromise("/api/billing/listBills", data, token).then((e) => {
    if (!e.data.error) {
      let list = [];
      const data = e.data.response;
      for (let i = 0; i < data.length; i++) {
        list.push({
          ...data[i],
          id: i,
        });
      }
      setBillCartList(list);
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Somthing went wrong",
        })
      );
    }
  });
};
const tabs = [
  {
    label: "Sections Wise",
    icon: <CategoryIcon />,
    value: 0,
    color: "#f5874f",
  },
  { label: "Brand Wise", icon: <StarsIcon />, value: 1, color: "#a8cf45" },
];

export default function CustomTabs({ tab, setTab }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        mb: 1,
      }}
    >
      {tabs.map(({ label, icon, value, color }) => (
        <ButtonBase
          key={label}
          onClick={() => setTab(value)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: "12px",
            backgroundColor: tab === value ? color : "#e6e6e3",
            color: tab === value ? "#fff" : "#0d0d0d",
            transition: "all 0.3s",
            boxShadow: tab === value ? "0 4px 10px rgba(0,0,0,0.15)" : "none",
            "&:hover": {
              backgroundColor: tab === value ? color : "#bebaba",
            },
          }}
        >
          {icon}
          <Typography>{label}</Typography>
        </ButtonBase>
      ))}
    </Box>
  );
}
export const listSectionMasterApi = (prefix, token, setRows, dispatch) => {
  const data = {
    table_prefix: prefix,
    SECTION_NAME: "",
  };
  CallAPIPromise(`/api/subMasterUtils/listSectionMaster`, data, token)
    .then(async function (response) {
      if (!response.data.error) {
        let list = [];
        const data = response.data.response;

        for (let i = 0; i < data.length; i++) {
          list.push({
            ...data[i],
            id: i,
          });
        }

        dispatch(setSectionList(list));
        if (isPosMod) {
          const databaseName = "SectionMaster";
          const storeName = "SectionList";
          const dataToSave = list;
          HandleIndexedDB({ databaseName, storeName, dataToSave });
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Error 112",
            msg: response.data.error,
          })
        );
      }
    })
    .catch(function (error) {
      if (error.response.data.name === "TokenExpiredError") {
        dispatch(setSessionExpired(true));
        console.log(error.response);
      } else {
        dispatch(
          setAlertWithTitle({
            title: "ERROR",
            msg: "Something went wrong.",
            lottie: "reject",
          })
        );
      }
    })
    .finally(() => {
      dispatch(setSpinnerLoading(false));
    });
};

export const GetlistCustomerList = (prefix, token, setRows, dispatch) => {
  const data = {
    table_prefix_master: prefix.replace(/_.+_/, "_"),
    CUSTOMER_MOBILE: "",
    CUSTOMER_NAME: "",
  };
  CallAPIPromise(`/api/customerMasterUtils/listCustomerMaster`, data, token)
    .then(async function (response) {
      if (!response.data.error) {
        const data = response.data.response;

        setRows(data);
        if (isPosMod) {
          const databaseName = "CustomerMaster";
          const storeName = "CustomerList";
          const dataToSave = data;
          HandleIndexedDB({ databaseName, storeName, dataToSave });
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Error 112",
            msg: response.data.error,
          })
        );
        console.log(!response.data.error);
      }
    })
    .catch(function (error) {
      if (error.response.data.name === "TokenExpiredError") {
        dispatch(setSessionExpired(true));
        console.log(error.response);
      } else {
        dispatch(
          setAlertWithTitle({
            title: "ERROR",
            msg: "Something went wrong.",
            lottie: "reject",
          })
        );
      }
    })
    .finally(() => {
      dispatch(setSpinnerLoading(false));
    });
};

export const LoadBill = (
  prefix,
  token,
  dispatch,
  inv,
  setBillCartList,
  setCustomerDetails,
  setBillingDetails,
  setDate,
  bill_performa,
  isRemoveINVNO
) => {
  return new Promise((resolve, reject) => {
    const data = {
      table_prefix: prefix,
      ORDER_NO: inv,
    };
    CallAPIPromise("/api/stockorders/loadStockOrders", data, token).then(
      (e) => {
        if (!e.data.error) {
          const data = e.data.response;
          let list = [];
          setDate(moment(data[0].DATE).format("YYYY-MM-DD"));
          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              DATE: moment(data[i].DATE).format("YYYY-MM-DD"),
            });
          }
          resolve(list);

          setBillCartList(list);
          setCustomerDetails({
            CUSTOMER_NAME: data[0].CUSTOMER_NAME,
            CUSTOMER_ADDRESS: data[0].CUSTOMER_ADDRESS,
            CUSTOMER_MOBILE: data[0].CUSTOMER_MOBILE,
            CUSTOMER_EMAIL: data[0].CUSTOMER_EMAIL,
            CUSTOMER_TYPE: "",
            CITY: "",
            COUNTRY: "",
            PIN_CODE: "",
            DISQ_RATE: data[0].DISQ_RATE,
            LOYALTY_POINTS: "",
            CUSTOMER_STATUS: "",
            PRV_BAL: "",
            BAL_TYPE: "",
            CUSTOMER_CODE: data[0].CUSTOMER_CODE,
          });

          setBillingDetails({
            mobile: data[0].CUSTOMER_MOBILE,
            customerName: data[0].CUSTOMER_NAME,
            cashAmount: data[0].CASH_AMOUNT,
            cardAmount: data[0].CARD_AMOUNT,
            cardNo: data[0].CARD_NO,
            eAmount: 0,
            btcAmount: data[0].BTC_AMOUNT,
            btcName: data[0].NAME,
            couponAmount: data[0].COUPAN_AMOUNT,
            couponNo: data[0].COUPAN_NO,
            HANDLING_CHARGES: data[0].HANDLING_CHARGES
              ? data[0].HANDLING_CHARGES
              : 0,
            DELIVERY_CHARGES: data[0].DELIVERY_CHARGES
              ? data[0].DELIVERY_CHARGES
              : 0,
          });
        } else {
          reject();
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "Something went wrong",
            })
          );
        }
      }
    );
  });
};

export const editBillFields = (
  e,
  setBillCartList,
  dispatch,
  billCartList,
  billingDetails,
  customerDetails,
  setAlertTwoButtonModal,
  setBillingDetails,
  profileSetting,
  setCustomerDetails
) => {
  if (e.field === "QNTY") {
    if (Number(e.value) === 0) {
      const item = billCartList.filter((c) => c.ICODE === e.id);
      if (item[0].RQNTY < 1) {
        setBillCartList((b) => b.filter((c) => c.ICODE !== e.id));
      }
    } else {
      const box = billCartList.filter((c) => c.ICODE === e.id);
      if (box[0]) {
        itemClick(
          box[0],
          box[0],
          setBillCartList,
          billingDetails,
          customerDetails,
          Number(e.value),
          dispatch,
          setAlertTwoButtonModal,
          true,
          "",
          "",
          "",
          true,
          profileSetting,
          billCartList
        );
      }
    }
  } else {
    if (e.field === "SALE_PRICE") {
      if (e.value > 0) {
        setBillCartList((c) => {
          const data = c.map((b) => {
            if (b.ICODE === e.id) {
              return {
                ...b,
                SALE_PRICE: e.value,
                AMOUNT: e.value * b.QNTY,
                NET_AMOUNT: e.value * b.QNTY,
              };
            } else {
              return b;
            }
          });

          deleteWholeDatabase("billing").then(() => {
            dataToLocal("billing", data, [
              {
                ICODE: 1,
              },
            ]);
          });

          return data;
        });
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Sale Price not found",
          })
        );
      }
    } else {
      if (e.field === "RQNTY") {
        if (Number(e.value) === 0) {
          const item = billCartList.filter((c) => c.ICODE === e.id);
          if (item[0].RQNTY > 0) {
            setBillCartList((b) => {
              const data = b.filter((c) => c.ICODE !== e.id);
              deleteWholeDatabase("billing").then(() => {
                dataToLocal("billing", data, [
                  {
                    ICODE: 1,
                  },
                ]);
              });

              return data;
            });
          } else {
            setBillCartList((c) => {
              const data = c.map((b) => {
                if (b.ICODE === e.id) {
                  return {
                    ...b,
                    RQNTY: e.value,
                    AMOUNT: e.value * b.SALE_PRICE,
                    DISQ_AMT: "0",
                    NET_AMOUNT: e.value * b.SALE_PRICE,
                  };
                } else {
                  return b;
                }
              });
              deleteWholeDatabase("billing").then(() => {
                dataToLocal("billing", data, [
                  {
                    ICODE: 1,
                  },
                ]);
              });
              return data;
            });
          }
        } else {
          setBillCartList((c) => {
            const data = c.map((b) => {
              if (b.ICODE === e.id) {
                return {
                  ...b,
                  RQNTY: e.value,
                  QNTY: "0",
                  AMOUNT: e.value * b.SALE_PRICE,
                  DISQ_AMT: "0",
                  NET_AMOUNT: e.value * b.SALE_PRICE,
                };
              } else {
                return b;
              }
            });
            deleteWholeDatabase("billing").then(() => {
              dataToLocal("billing", data, [
                {
                  ICODE: 1,
                },
              ]);
            });
            return data;
          });
        }
      } else {
        if (e.field === "DISQ_AMT") {
          setBillCartList((c) => {
            const data = c.map((b) => {
              if (b.ICODE === e.id) {
                if (b.SALE_PRICE * b.QNTY > e.value) {
                  const basicRate = b.SALE_PRICE * b.QNTY;
                  const a = b.SALE_PRICE * b.QNTY - e.value;
                  return {
                    ...b,
                    DISQ_AMT: e.value,
                    NET_AMOUNT: a,
                    AMOUNT: b.SALE_PRICE * b.QNTY,

                    DISQ_RATE: (e.value / basicRate) * 100,
                  };
                } else {
                  dispatch(
                    setAlertWithTitle({
                      title: "Alert",
                      msg: "You Cannot give discount more than amount.",
                      horizontal: true,
                    })
                  );
                  return b;
                }
              } else {
                return b;
              }
            });

            deleteWholeDatabase("billing").then(() => {
              dataToLocal("billing", data, [
                {
                  ICODE: 1,
                },
              ]);
            });
            return data;
          });
        } else {
          if (e.field === "DISQ_RATE") {
            setBillCartList((c) => {
              const data = c.map((b) => {
                if (b.ICODE === e.id) {
                  const am = Number(b.QNTY) * Number(b.SALE_PRICE);
                  const disqAmount = FormatNumber2(
                    (am * Number(e.value)) / 100
                  );
                  if (am > disqAmount) {
                    const amt = am - disqAmount;
                    return {
                      ...b,
                      DISQ_AMT: disqAmount,
                      NET_AMOUNT: amt,
                      AMOUNT: am,
                      DISQ_RATE: Number(e.value),
                    };
                  } else {
                    dispatch(
                      setAlertWithTitle({
                        title: "Alert",
                        msg: "You Cannot give discount more than amount.",
                        horizontal: true,
                      })
                    );
                    return b;
                  }
                } else {
                  return b;
                }
              });
              deleteWholeDatabase("billing").then(() => {
                dataToLocal("billing", data, [
                  {
                    ICODE: 1,
                  },
                ]);
              });

              return data;
            });
          } else {
            if (e.field === "CASH") {
              setBillingDetails((o) => {
                return {
                  ...o,
                  cashAmount: Number(e.value),
                };
              });
            } else {
              if (e.field === "CARD_AMT") {
                setBillingDetails((o) => {
                  return {
                    ...o,
                    cardAmount: Number(e.value),
                  };
                });
              } else {
                if (e.field === "CARD_NUMBER") {
                  setBillingDetails((o) => {
                    return {
                      ...o,
                      cardNo: Number(e.value),
                    };
                  });
                } else {
                  if (e.field === "EAMOUNT") {
                    setBillingDetails((o) => {
                      return {
                        ...o,
                        eAmount: Number(e.value),
                      };
                    });
                  } else {
                    if (e.field === "BTC_AMT") {
                      setBillingDetails((o) => {
                        return {
                          ...o,
                          btcAmount: Number(e.value),
                        };
                      });
                    } else {
                      if (e.field === "BTC_NAME") {
                        setBillingDetails((o) => {
                          return {
                            ...o,
                            btcName: Number(e.value),
                          };
                        });
                      } else {
                        if (e.field === "COUPAN_AMT") {
                          setBillingDetails((o) => {
                            return {
                              ...o,
                              couponAmount: Number(e.value),
                            };
                          });
                        } else {
                          if (e.field === "COUPAN_NO") {
                            setBillingDetails((o) => {
                              return {
                                ...o,
                                couponNo: Number(e.value),
                              };
                            });
                          } else {
                            if (e.field === "DISQ_RATE_ALL") {
                              const value = e.value ? e.value : 0;
                              setBillCartList((c) => {
                                const data = c.map((b) => {
                                  if (b.RQNTY === 0 || !b.RQNTY) {
                                    const am =
                                      Number(b.QNTY) * Number(b.SALE_PRICE);
                                    const disqAmount =
                                      (am * Number(value)) / 100;
                                    if (am > disqAmount) {
                                      const amt = am - disqAmount;
                                      const data = {
                                        ...b,
                                        DISQ_AMT: disqAmount,
                                        NET_AMOUNT: amt,
                                        AMOUNT: am,

                                        DISQ_RATE: Number(value),
                                      };
                                      return data;
                                    } else {
                                      dispatch(
                                        setAlertWithTitle({
                                          title: "Alert",
                                          msg: "You Cannot give discount more than amount.",
                                          horizontal: true,
                                        })
                                      );
                                      return b;
                                    }
                                  } else {
                                    return b;
                                  }
                                });
                                deleteWholeDatabase("billing").then(() => {
                                  dataToLocal("billing", data, [
                                    {
                                      ICODE: 1,
                                    },
                                  ]);
                                });

                                return data;
                              });
                            } else {
                              if (e.field === "DISQ_AMT_ALL") {
                                const value = e.value ? e.value : 0;

                                setBillCartList((c) => {
                                  const data = c.map((b) => {
                                    const totalAmt = billCartList.reduce(
                                      (acc, row) =>
                                        acc +
                                        Number(
                                          row.RQNTY > 0 || !row.RQNTY
                                            ? row.QNTY * row.SALE_PRICE
                                            : 0
                                        ),
                                      0
                                    );
                                    const disqAmt = value;
                                    const disqRate = (disqAmt / totalAmt) * 100;
                                    if (b.RQNTY === 0 || !b.RQNTY) {
                                      const am =
                                        Number(b.QNTY) * Number(b.SALE_PRICE);
                                      const disqAmount =
                                        (am * Number(disqRate)) / 100;
                                      if (am > disqAmount) {
                                        const amt = am - disqAmount;
                                        const data = {
                                          ...b,
                                          DISQ_AMT: disqAmount,
                                          NET_AMOUNT: amt,
                                          AMOUNT: am,

                                          DISQ_RATE: Number(disqRate),
                                        };
                                        return data;
                                      } else {
                                        dispatch(
                                          setAlertWithTitle({
                                            title: "Alert",
                                            msg: "You Cannot give discount more than amount.",
                                            horizontal: true,
                                          })
                                        );
                                        return b;
                                      }
                                    } else {
                                      return b;
                                    }
                                  });
                                  deleteWholeDatabase("billing").then(() => {
                                    dataToLocal("billing", data, [
                                      {
                                        ICODE: 1,
                                      },
                                    ]);
                                  });

                                  return data;
                                });
                              } else {
                                if (e.field === "HANDLING_CHARGES") {
                                  setBillingDetails((o) => {
                                    return {
                                      ...o,
                                      HANDLING_CHARGES: Number(e.value),
                                    };
                                  });
                                } else {
                                  if (e.field === "DELIVERY_CHARGES") {
                                    setBillingDetails((o) => {
                                      return {
                                        ...o,
                                        DELIVERY_CHARGES: Number(e.value),
                                      };
                                    });
                                  } else {
                                    if (e.field === "CUSTOMER_MOBILE") {
                                      setCustomerDetails((o) => {
                                        return {
                                          ...o,
                                          CUSTOMER_MOBILE: e.value,
                                        };
                                      });
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export const onBillSave = (
  billCart,
  dispatch,
  prefix,
  token,
  Undo,
  TotalAmount,
  setBillNo,
  setAlertTwoButtonModal,
  setViewBillStatus,
  inputFields,
  SaleType,
  setModalStatus,
  isPrintHide,
  longitude,
  latitude,
  isPending,
  customerDetails,
  setIsOriginalBill,
  roundOffAmt,
  isCrossOrder,
  navigate,
  setPrintData,
  onClickPrintBill,
  isFromOrderScreen,
  paymentMethod = "COD"
) => {
  const billCartList = billCart.filter((b) => b.QNTY > 0 || b.RQNTY > 0);
  const store = Store.getState();
  const defaultSetting = store.profile.profileDefaultSetting;
  const userEmail = store.profile.email;
  const companyAddress = Store.getState().profile.companyAddress;

  if (!billCart.find((o) => o.QNTY < 1 && o.RQNTY < 1)) {
    if (billCartList[0]) {
      const list = billCartList.map((e) => {
        const data = {
          ...e,
          DATE: !e.DATE ? moment().format("YYYY-MM-DD HH:mm:ss") : e.DATE,
          USER_EMAIL: userEmail,
          COMPANY_NAME: companyAddress.companyName,
          ORDER_NO: e?.ORDER_NO ? e?.ORDER_NO : 0,
        };
        return data;
      });
      setPrintData(list);
      const data = {
        table_prefix: prefix,
        stock_order_cart: list,
        NEW_MODIFY: list[0].ORDER_NO ? "Modify" : "New",
      };
      if (list[0].INVNO) {
        setIsOriginalBill(false);
      } else {
        setIsOriginalBill(true);
      }
      SaveOrderStock(
        data,
        token,
        dispatch,
        isPending,
        setBillNo,
        setPrintData,
        list,
        billCartList,
        store,
        customerDetails,
        prefix,
        isFromOrderScreen,
        navigate,
        setModalStatus,
        isPrintHide,
        defaultSetting,
        setAlertTwoButtonModal,
        setViewBillStatus,
        Undo,
        onClickPrintBill
      );
    } else {
      dispatch(
        setAlertWithTitle({
          title: "No data found",
          msg: "No Data found to save",
        })
      );
    }
  } else {
    dispatch(
      setAlertWithTitle({
        title: "Zero Quantity Items Found",
        msg: "Please Remove Zero Qnty Items or add qnty",
      })
    );
  }
};

export const itemClick = (
  item,
  box,
  setBillCartList,
  billingDetails,
  customerDetails,
  q,
  dispatch,
  setAlertTwoButtonModal,
  edit,
  isStockCheck,
  prefix,
  token,
  isAllreadyInBillCart,
  profileSetting,
  billCartList,
  orderType
) => {
  const qty = q !== "ZERO" ? (q ? Number(q) : 1) : 0;
  const isInBill = billCartList.filter((o) => o.ICODE === box.ICODE);

  if (isAllreadyInBillCart || isInBill[0]) {
    addItem(
      setBillCartList,
      box,
      edit,
      qty ? qty : isInBill[0].QNTY,
      isStockCheck,
      setAlertTwoButtonModal,
      customerDetails,
      item,
      billingDetails,
      orderType
    );
  } else {
    addItem(
      setBillCartList,
      box,
      edit,
      box.ORDER_QNTY,
      isStockCheck,
      setAlertTwoButtonModal,
      customerDetails,
      item,
      billingDetails,
      orderType
    );
  }
};
export const addItem = (
  setBillCartList,
  box,
  edit,
  qty,
  isStockCheck,
  setAlertTwoButtonModal,
  customerDetails,
  item,
  billingDetails,
  orderType
) => {
  setBillCartList((oldCart, i) => {
    const isItemExist = oldCart.filter((i) => i.ICODE === box.ICODE);
    if (isItemExist[0]) {
      const data = oldCart.map((o) => {
        if (o.ICODE === box.ICODE) {
          const q = edit ? qty : Number(o.QNTY) + qty;

          return {
            ...o,
            QNTY: q,

            AMOUNT: Number(o.PUR_PRICE * q),
            TOTAL: Number(o.PUR_PRICE * q),
            RQNTY: 0,
          };
        } else
          return {
            ...o,
          };
      });
      deleteWholeDatabase("stock_ordering").then(() => {
        dataToLocal("stock_ordering", data, [
          {
            ICODE: 1,
          },
        ]);
      });
      return data;
    } else {
      const data = [
        ...oldCart,
        {
          ORDER_NO: 0,
          ORDER_TYPE: orderType,
          DATE: moment().format("YYYY-MM-DD HH:mm:ss"),
          ACCOUNT_NO: item.ACCOUNT_NO,
          NAME: item.NAME,
          ADDRESS: item.ADDRESS,
          MOBILE: item.MOBILE,
          TAX_NUMBER: "",
          ICODE: item.ICODE,
          ITEMNAME: item.ITEMNAME,
          ITEM_INSTRUCTIONS: "",
          ITEM_DESC: "",
          PACKING: item.PACKING,
          UNIT: item.UNIT,
          SECTION_NAME: item.SECTION_NAME,
          SUB_SEC_NAME: item.SUB_SEC_NAME,
          COLOR: "",
          SIZE: "",
          CATEGORY: "",
          BRAND_NAME: item.BRAND_NAME,
          PUR_PRICE: item.PUR_PRICE,
          MRP_RATE: item.MRP_RATE,
          QNTY: qty,
          RQNTY: 0,
          AMOUNT: item.PUR_PRICE * qty,
          HSN_CODE: item.HSN_CODE,
          TOTAL: item.PUR_PRICE * qty,
          REMARKS: "",
          LATITUDE: "31.3260",
          BAL_STOCK: item.BAL_STOCK,
          LONGITUDE: "75.5762",
          id: uniqueId(),
          PURCHASE_BILL_NO: 0,
        },
      ];
      deleteWholeDatabase("stock_ordering").then(() => {
        dataToLocal("stock_ordering", data, [
          {
            ICODE: 1,
          },
        ]);
      });

      return data;
    }
  });

  setTimeout(() => {
    const nearestInput = document.getElementById(box.ICODE + "-" + "QNTY");
    if (nearestInput) {
      nearestInput.focus();
    }
  }, 200);
  if (window.innerWidth > 1280) {
    setTimeout(() => {
      const nearestInput = document.getElementById("search");
      if (nearestInput) {
        nearestInput.focus();
      }
    }, 500);
  }
};
function SaveOrderStock(
  data,
  token,
  dispatch,
  isPending,
  setBillNo,
  setPrintData,
  list,
  billCartList,
  store,
  customerDetails,
  prefix,
  isFromOrderScreen,
  navigate,
  setModalStatus,
  isPrintHide,
  defaultSetting,
  setAlertTwoButtonModal,
  setViewBillStatus,
  Undo,
  onClickPrintBill
) {
  dispatch(setSpinnerLoading("Saving"));
  CallAPIPromise("/api/stockorders/saveStockOrder", data, token)
    .then((res) => {
      if (!res.data.error) {
        if (!isPending) {
          setBillNo(res.data?.INVNO);
        }
        setPrintData(
          list.map((l) => {
            return {
              ...l,
              ORDER_NO: res.data?.ORDER_NO,
            };
          })
        );

        deleteWholeDatabase("stock_ordering");
        if (setModalStatus) {
          setModalStatus();
        }

        if (!isPrintHide && !isPending) {
          if (defaultSetting?.PREVIEW_BILL_PRINT !== "No") {
            setAlertTwoButtonModal((e) => {
              return {
                ...e,
                title: `Bill Saved`,
                msg: `Do You want to print this bill ?`,
                status: true,
                button1: "Yes",
                button1Click: () => {
                  setAlertTwoButtonModal((e) => {
                    return {
                      ...e,
                      status: false,
                    };
                  });

                  setViewBillStatus(true);
                },
                button2: "Cancel",
                button1Bg: "#34b4eb",
                button2Bg: "#e1e2e3",
                button2Color: "black",
                button2Click: () => {
                  setAlertTwoButtonModal((e) => {
                    return {
                      ...e,
                      status: false,
                    };
                  });
                },
              };
            });
            Undo(res.data?.ORDER_NO);
          } else {
            if (defaultSetting?.PREVIEW_BILL_PRINT === "No") {
              setTimeout(() => {
                onClickPrintBill(
                  list.map((l) => {
                    return {
                      ...l,
                      ORDER_NO: res.data?.ORDER_NO,
                    };
                  })
                );
                Undo(res.data?.ORDER_NO);
                dispatch(setSpinnerLoading(false));
              }, 2000);
              // setTimeout(() => {
              //   setPrintData([]);
              // }, 3000);
            }
          }
        } else {
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: `Bill Saved for Hold`,
            })
          );
          Undo();
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Error",
            msg: res.data.error,
          })
        );
      }
    })
    .catch(() => {
      dispatch(
        setAlertWithTitle({
          title: "Error",
          msg: "Something went wrong",
        })
      );
    })
    .finally(() => {
      if (defaultSetting?.PREVIEW_BILL_PRINT !== "No") {
        setTimeout(() => {
          dispatch(setSpinnerLoading(false));
        }, 1000);
      }
    });
}
